module.exports = __webpack_public_path__ + "static/media/broadcast-black.14d3bc82.svg";